import { render, staticRenderFns } from "./CExamKind.vue?vue&type=template&id=64dc5288"
import script from "./CExamKind.vue?vue&type=script&lang=js"
export * from "./CExamKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports